import { useTranslation } from "react-i18next";

import { useAlertContext } from "../alert/AlertContext";
import { isResponseError } from "../api/responseError";
import { PreviewNotImplementedError, PreviewStatusCode } from "./previewErrors";
import { useFilePreview } from "./useFilePreview";

interface UseFilePreviewWithAlertParams {
  fetchBlob: () => Promise<Blob>;
}

/**
 * Wraps the shared {@link useFilePreview} state machine with alert-based error reporting,
 * mapping the preview error cases (not implemented / not ready / failed) to toasts.
 */
export function useFilePreviewWithAlert({ fetchBlob }: UseFilePreviewWithAlertParams) {
  const { t } = useTranslation();
  const { showError } = useAlertContext();

  return useFilePreview({
    fetchBlob,
    onError: (error: unknown) => {
      if (error instanceof PreviewNotImplementedError) {
        showError(t("dropzone.fileList.previewNotImplemented"));
      } else if (isResponseError(error) && error.response.status === PreviewStatusCode.NotReady) {
        showError(t("dropzone.fileList.previewNotReady"));
      } else if (isResponseError(error) && error.response.status === PreviewStatusCode.Failed) {
        showError(t("dropzone.fileList.previewFailed"));
      } else {
        showError(t("dropzone.fileList.previewError"));
      }
    },
  });
}
